import * as React from 'react'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import configurator from 'modules/app_store/lib/SubscriptionAddonConfigurator'
import { getApplicationLabels } from 'modules/app_store/lib/getApplicationLabels'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

interface Props {
  subscriptionAddon: SubscriptionAddon
}

const HelpLink = ({ subscriptionAddon }: Props) => {
  const { navigation } = useNavigation()
  const helpLink = configurator.helpLink(subscriptionAddon, navigation)
  const supportLink = configurator.supportLink(subscriptionAddon, navigation)

  if (!helpLink) return null

  const getCopy = () => {
    if (helpLink === 'new_request') {
      return i18n.t('app_store_v2.common.contact_support')
    }

    const id = subscriptionAddon.attributes.id
    const type = subscriptionAddon.isApp ? 'app' : 'integration'
    const { title } = getApplicationLabels(type, id)

    if (subscriptionAddon.isApp) {
      return i18n.t('app_store_v2.common.learn_more_app', {
        title,
      })
    }

    return i18n.t('app_store_v2.common.learn_more_integration', {
      title,
    })
  }

  return (
    <HelpCenterLink link={supportLink} name={helpLink}>
      {getCopy()}
    </HelpCenterLink>
  )
}

export default HelpLink
